<template>
  <div class="flow-status" :style="dotStyle">
    <div class="animation" :style="animationStyle"></div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 8
    },
    color: {
      type: String,
      default: "#2d8cf0"
    }
  },
  computed: {
    dotStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        backgroundColor: this.color
      };
    },
    animationStyle() {
      return {
        borderColor: this.color
      };
    }
  }
};
</script>

<style scoped lang="scss">
.flow-status {
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
  position: relative;
  top: -1px;

  .animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    animation: aniStatusProcessing 1.2s infinite ease-in-out;
  }
}
</style>